<template>
  <TransitionRoot
    appear
    :show="isOpen"
    :unmount="false"
    as="template">
    <Dialog
      static
      :open="isOpen"
      as="div"
      class="fixed inset-0 z-50 flex max-h-screen items-center justify-center px-4 py-4 lg:py-8"
      data-lenis-prevent
      @close="setIsOpen">
      <TransitionChild
        as="template"
        :unmount="false"
        enter="duration-300 ease-out"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="duration-200 ease-in"
        leave-from="opacity-100"
        leave-to="opacity-0">
        <div
          class="absolute inset-0 bg-black/30"
          aria-hidden="true"
          @click="setIsOpen(false)" />
      </TransitionChild>

      <TransitionChild
        as="template"
        :unmount="false"
        enter="duration-300 ease-out"
        enter-from="opacity-0 scale-95"
        enter-to="opacity-100 scale-100"
        leave="duration-200 ease-in"
        leave-from="opacity-100 scale-100"
        leave-to="opacity-0 scale-95">
        <DialogPanel
          data-lenis-prevent
          class="relative z-10 flex max-h-full w-full max-w-[1140px] flex-col overflow-auto rounded-3xl bg-white pt-16 max-lg:min-h-full lg:pt-20">
          <ClientOnly>
            <JobModalPublicGreenhouseForm :id="id" />
          </ClientOnly>

          <IconCloseLine
            class="absolute right-4 top-4 h-10 w-10 cursor-pointer lg:right-6 lg:top-6"
            @click="setIsOpen(false)" />
        </DialogPanel>
      </TransitionChild>
    </Dialog>
  </TransitionRoot>
</template>

<script setup lang="ts">
  import { Dialog, DialogPanel, TransitionChild, TransitionRoot } from '@headlessui/vue'

  type Props = {
    id: string
    isOpen: boolean
  }

  defineProps<Props>()
  const emit = defineEmits(['toggle'])

  function setIsOpen(isOpen: boolean) {
    emit('toggle', isOpen)
  }
</script>
